import { render, staticRenderFns } from "./NoGoCompanies.vue?vue&type=template&id=72249c66"
import script from "./NoGoCompanies.vue?vue&type=script&lang=js"
export * from "./NoGoCompanies.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports